export default "__VITE_ASSET__C0CRZad4__"